<ng-container *ngIf="config.showFirstLastButtons; else withoutFirstLastButtons">
    <mat-paginator
        [length]="config.length"
        [pageIndex]="config.pageIndex"
        [pageSize]="config.pageSize"
        [pageSizeOptions]="config.pageSizeOptions"
        (page)="changePageOption.emit($event)"
        showFirstLastButtons
    >
    </mat-paginator>
</ng-container>

<ng-template #withoutFirstLastButtons>
    <mat-paginator
        [length]="config.length"
        [pageIndex]="config.pageIndex"
        [pageSize]="config.pageSize"
        [pageSizeOptions]="config.pageSizeOptions"
        (page)="changePageOption.emit($event)"
    >
    </mat-paginator>
</ng-template>
